import { z } from 'zod';

/**
 * Environment variable schema with Zod validation
 * Validates all required environment variables at startup
 */
const envSchema = z.object({
  // Feature Flags
  VITE_ENABLE_ANALYTICS: z
    .string()
    .optional()
    .transform((val) => val === 'true'),

  // App Info
  VITE_RELEASE_VERSION: z.string().optional(),
  VITE_ENVIRONMENT: z.enum(['development', 'staging', 'production']).default('development'),
  VITE_EMAIL_DOMAIN: z.string().optional().default(''),

  // Sentry
  VITE_SENTRY_DSN: z.string().optional(),
});

// Validate environment variables
const _env = envSchema.safeParse(import.meta.env);

if (!_env.success) {
  console.error('❌ Invalid environment variables:', _env.error.format());
  throw new Error('Invalid environment variables');
}

export const env = _env.data;

/**
 * Type-safe environment variable access
 */
export type Env = typeof env;
